"use client";
import React, { useState } from "react";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import Popup from "./popup";
import Call from "@/app/assets/CallFill.svg";
import clsx from "clsx";

const PracticeAreasContent = ({ practiceAreas, phoneNumber }) => {
  const [selectedArea, setSelectedArea] = useState(null);

  const handleClick = (item) => {
    setSelectedArea(item);
  };

  const closePopup = () => {
    setSelectedArea(null);
  };

  return (
    <div className="relative h-full">
      {!selectedArea && (
        <div className="grid justify-between w-full grid-cols-1 md:grid-cols-2">
          {practiceAreas?.map((item, idx) => {
            return (
              <div
                key={item?.id}
                className="flex gap-4 border-b-[0.5px] border-[#FFFFFF4D] py-[20px] cursor-pointer group"
                onClick={() => handleClick(item)}
              >
                <MdOutlineArrowRightAlt
                  size={22}
                  className="text-[#C4C4C8] group-hover:text-[#EEB978]"
                />
                <h3 className="font-title title-small text-[#fff] group-hover:text-[#EEB978]">
                  {item?.data?.practice_title}
                </h3>
              </div>
            );
          })}
        </div>
      )}

      <div
        className={clsx({
          "transition-all duration-[800ms]": true,
          "opacity-0": !selectedArea,
          "opacity-100": !!selectedArea,
        })}
      >
        {selectedArea && (
          <Popup
            title={selectedArea?.data?.practice_title}
            content={selectedArea.data?.popup_description}
            callButtonIcon={Call}
            callButtonLabel={phoneNumber}
            callButtonLink={{
              link_type: "Web",
              url: `tel:${phoneNumber}`,
            }}
            viewButtonLabel={"View More"}
            viewButtonLink={`/practice-areas/${selectedArea?.uid}`}
            onClose={closePopup}
          />
        )}
      </div>
    </div>
  );
};

export default PracticeAreasContent;
